import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '@tv3/shared/shared.module'
import { TaskStatusComponent } from '@tv3/containers/tasks/shared/task-status/task-status.component'
import { TaskDialogComponent } from '@tv3/containers/tasks/shared/task-dialog/task-dialog.component'
import { TaskConversationsComponent } from './shared/task-dialog/task-conversations/task-conversations.component'
import { TaskHistoryComponent } from './shared/task-dialog/task-history/task-history.component'
import { TaskChecklistComponent } from './shared/task-dialog/task-checklist/task-checklist.component'
import { TaskInquiryDetailsComponent } from './shared/task-dialog/task-inquiry-details/task-inquiry-details.component'
import { TaskStarBtnComponent } from '@tv3/containers/tasks/shared/task-star-btn/task-star-btn.component'
import { CommentsLibraryModule } from '@tokeet-frontend/comments'
import { ActivityLibraryModule } from '@tokeet-frontend/activity'
import { InquirySharedModule } from '../inquiries/overlays/inquiry-overlay/inquiry-shared.module'
import { DefaultTaskViewComponent } from './shared/default-task-view/default-task-view.component'
import { TaskListPopupComponent } from './calendar-view/task-list-popup/task-list-popup.component'
import { IncidentsStoreModule } from '@tokeet-frontend/incident'
import { TaskViewDialogService } from '@tv3/containers/tasks/shared/task-view-dialog.service'
import { TaskAssigneeSelectComponent } from './shared/task-assignee-select/task-assignee-select.component'
import { VendorsLibraryModule } from '@tokeet-frontend/vendors'
import { TaskVendorImagesComponent } from './shared/task-dialog/task-vendor-images/task-vendor-images.component'
import { TasksLibModule } from '@tokeet-frontend/tasks'
import { ApproveDraftTasksDialogComponent } from './approve-draft-tasks-dialog/approve-draft-tasks-dialog.component'
import { DiscountsSharedModule } from '@tv3/containers/discounts/discounts-shared.module'
import { RatePushAutomationsModule } from '@tv3/containers/rates/rate-push-automations/rate-push-automations.module'
import { RatesSharedModule } from '@tv3/containers/rates/rates-shared.module'
import { AutomationDraftTasksComponent } from './approve-draft-tasks-dialog/automation-draft-tasks/automation-draft-tasks.component'
import { ReviewDraftTasksComponent } from './approve-draft-tasks-dialog/review-draft-tasks/review-draft-tasks.component'
import { MessageDraftTasksComponent } from './approve-draft-tasks-dialog/message-draft-tasks/message-draft-tasks.component'
import { AiResponderSharedModule } from '@tv3/containers/ai-responder/ai-responder-shared.module'
import { BulkEditTasksDialogComponent } from './bulk-edit-tasks-dialog/bulk-edit-tasks-dialog.component'

const components = [
  //
  TaskStatusComponent,
  TaskStarBtnComponent,
  DefaultTaskViewComponent,
  TaskAssigneeSelectComponent,
]

const dialogs = [
  //
  TaskConversationsComponent,
  TaskInquiryDetailsComponent,
  TaskHistoryComponent,
  TaskChecklistComponent,
  TaskVendorImagesComponent,
  TaskDialogComponent,
  TaskListPopupComponent,
  AutomationDraftTasksComponent,
  MessageDraftTasksComponent,
  ReviewDraftTasksComponent,
  ApproveDraftTasksDialogComponent,
  BulkEditTasksDialogComponent,
]

const modules = [
  //
  SharedModule,
  CommentsLibraryModule,
  ActivityLibraryModule,
  InquirySharedModule,
  IncidentsStoreModule,
  VendorsLibraryModule,
  TasksLibModule,
  AiResponderSharedModule,
]

const services = [TaskViewDialogService]

@NgModule({
  imports: [
    //
    CommonModule,
    ...modules,
    DiscountsSharedModule,
    RatePushAutomationsModule,
    RatesSharedModule,
  ],
  declarations: [...components, ...dialogs],
  exports: [...components, ...dialogs, ...modules],
  providers: [...services],
})
export class TasksSharedModule {}
